function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "vulnerability");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Visual-screens-April-May-June-21",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Artboard",
  transform: "translate(-128.000000, -49.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "add",
  transform: "translate(128.000000, 49.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "0 0 24 0 24 24 0 24"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.5,3 L5,6.27272727 L5,11.1818182 C5,15.7227273 8.2,19.9690909 12.5,21 C16.8,19.9690909 20,15.7227273 20,11.1818182 L20,6.27272727 L12.5,3 Z M12.5,11.9918182 L18.3333333,11.9918182 C17.8916667,15.3627273 15.6,18.3654545 12.5,19.3063636 L12.5,12 L6.66666667,12 L6.66666667,7.33636364 L12.5,4.79181818 L12.5,11.9918182 Z",
  id: "Shape",
  fill: "#18C7B6",
  fillRule: "nonzero"
}))));

var SvgVulnerability = function SvgVulnerability(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVulnerability, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vulnerability.05ecc3f3.svg";
export { ForwardRef as ReactComponent };